import { Route, Routes } from 'react-router'
import { ListRoutes } from './routes'
import Logout from '@/pages/Logout'
import { useAuth } from '@/hooks/useAuth'

export function Router() {
  const { isAuthenticated } = useAuth()

  return (
    <Routes>
      {ListRoutes().map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            !isAuthenticated && route.isPrivate ? <Logout /> : route.element
          }
        />
      ))}
    </Routes>
  )
}
